"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopoverTrigger = exports.PopoverLink = exports.PopoverItemText = exports.PopoverItem = exports.PopoverBody = exports.Popover = exports.Link = exports.Label = exports.HiddenNode = exports.Container = exports.Arrow = exports.ActiveBreadcrumb = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _constants = require("../../../constants");
var _Label = _interopRequireDefault(require("../../../../components/Label"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Link = exports.Link = _styledComponents.default.a.withConfig({
  displayName: "styles__Link",
  componentId: "sc-1q8c9x9-0"
})(["color:", ";cursor:pointer;font-family:", ";font-size:", ";font-weight:", ";position:relative;line-height:", ";max-width:220px;display:block;text-overflow:ellipsis;overflow:hidden;&:hover{color:", ";text-decoration:underline;}"], ({
  theme
}) => theme.colors.appFrame.breadcrumbs.linkColor, ({
  theme
}) => theme.AppFrame.breadcrumbs.fontFamily, ({
  theme
}) => theme.AppFrame.breadcrumbs.fontSize, ({
  theme
}) => theme.AppFrame.breadcrumbs.fontWeight, ({
  theme
}) => theme.AppFrame.breadcrumbs.lineHeight, ({
  theme
}) => theme.colors.appFrame.breadcrumbs.hoverColor);
const ActiveBreadcrumb = exports.ActiveBreadcrumb = _styledComponents.default.span.withConfig({
  displayName: "styles__ActiveBreadcrumb",
  componentId: "sc-1q8c9x9-1"
})(["color:", ";font-family:", ";font-size:", ";font-weight:", ";position:relative;line-height:", ";max-width:220px;display:block;text-overflow:ellipsis;overflow:hidden;"], ({
  theme
}) => theme.colors.appFrame.breadcrumbs.color, ({
  theme
}) => theme.AppFrame.breadcrumbs.fontFamily, ({
  theme
}) => theme.AppFrame.breadcrumbs.fontSize, ({
  theme
}) => theme.AppFrame.breadcrumbs.fontWeight, ({
  theme
}) => theme.AppFrame.breadcrumbs.lineHeight);
const PopoverItem = exports.PopoverItem = _styledComponents.default.div.withConfig({
  displayName: "styles__PopoverItem",
  componentId: "sc-1q8c9x9-2"
})(["border-bottom:1px solid ", ";&:hover{background-color:", ";}&:last-child{border-bottom:0;}"], ({
  theme
}) => theme.colors.appFrame.breadcrumbs.popoverItemBorder, ({
  theme
}) => theme.colors.appFrame.breadcrumbs.popoverItemHover);
const PopoverItemText = exports.PopoverItemText = _styledComponents.default.span.withConfig({
  displayName: "styles__PopoverItemText",
  componentId: "sc-1q8c9x9-3"
})(["padding:", ";display:block;font-family:", ";font-size:", ";font-weight:", ";line-height:", ";color:", ";cursor:default;"], ({
  theme
}) => theme.AppFrame.breadcrumbs.popover.itemPadding, ({
  theme
}) => theme.AppFrame.breadcrumbs.popover.itemFontFamily, ({
  theme
}) => theme.AppFrame.breadcrumbs.popover.itemFontSize, ({
  theme
}) => theme.AppFrame.breadcrumbs.popover.itemFontWeight, ({
  theme
}) => theme.AppFrame.breadcrumbs.popover.itemLineHeight, ({
  theme
}) => theme.colors.appFrame.breadcrumbs.popoverItemColor);
const PopoverLink = exports.PopoverLink = _styledComponents.default.a.withConfig({
  displayName: "styles__PopoverLink",
  componentId: "sc-1q8c9x9-4"
})(["padding:", ";display:block;font-family:", ";font-size:", ";font-weight:", ";line-height:", ";color:", ";cursor:pointer;position:relative;&:hover{color:", ";}"], ({
  theme
}) => theme.AppFrame.breadcrumbs.popover.itemPadding, ({
  theme
}) => theme.AppFrame.breadcrumbs.popover.itemFontFamily, ({
  theme
}) => theme.AppFrame.breadcrumbs.popover.itemFontSize, ({
  theme
}) => theme.AppFrame.breadcrumbs.popover.itemFontWeight, ({
  theme
}) => theme.AppFrame.breadcrumbs.popover.itemLineHeight, ({
  theme
}) => theme.colors.appFrame.breadcrumbs.popoverItemLinkColor, ({
  theme
}) => theme.colors.appFrame.breadcrumbs.popoverItemTextHover);
const PopoverTrigger = exports.PopoverTrigger = _styledComponents.default.span.withConfig({
  displayName: "styles__PopoverTrigger",
  componentId: "sc-1q8c9x9-5"
})(["color:", ";cursor:pointer;font-family:", ";font-size:", ";font-weight:", ";line-height:", ";", ""], ({
  theme
}) => theme.colors.appFrame.breadcrumbs.color, ({
  theme
}) => theme.AppFrame.breadcrumbs.fontFamily, ({
  theme
}) => theme.AppFrame.breadcrumbs.fontSize, ({
  theme
}) => theme.AppFrame.breadcrumbs.fontWeight, ({
  theme
}) => theme.AppFrame.breadcrumbs.lineHeight, ({
  theme,
  isOpen
}) => theme.name === _constants.THEMES.mds && (0, _styledComponents.css)(["&:hover{color:", ";}", ""], theme.colors.appFrame.breadcrumbs.hoverColor, isOpen && (0, _styledComponents.css)(["color:", ";"], theme.colors.appFrame.breadcrumbs.hoverColor)));
const Popover = exports.Popover = _styledComponents.default.div.withConfig({
  displayName: "styles__Popover",
  componentId: "sc-1q8c9x9-6"
})(["background:", ";box-shadow:", ";padding:", ";max-width:450px;z-index:300;"], ({
  theme
}) => theme.colors.appFrame.breadcrumbs.popoverBg, ({
  theme
}) => theme.AppFrame.breadcrumbs.popover.shadow, ({
  theme
}) => theme.AppFrame.breadcrumbs.popover.padding);
const PopoverBody = exports.PopoverBody = _styledComponents.default.div.withConfig({
  displayName: "styles__PopoverBody",
  componentId: "sc-1q8c9x9-7"
})(["position:relative;"]);
const Arrow = exports.Arrow = _styledComponents.default.div.withConfig({
  displayName: "styles__Arrow",
  componentId: "sc-1q8c9x9-8"
})(["position:absolute;width:14px;height:14px;&[data-placement*='bottom']{top:0;left:0;margin-top:-5px;width:14px;height:10px;&::before{border-width:0 7px 5px 7px;border-color:transparent transparent ", " transparent;}}&[data-placement*='top']{visibility:hidden;bottom:0;left:0;margin-bottom:-9px;width:14px;height:10px;&::before{border-width:5px 7px 0 7px;border-color:", " transparent transparent transparent;}}&::before{content:'';margin:auto;display:block;width:0;height:0;border-style:solid;}"], ({
  theme
}) => theme.colors.appFrame.breadcrumbs.popoverBg, ({
  theme
}) => theme.colors.appFrame.breadcrumbs.popoverBg);
const Container = exports.Container = _styledComponents.default.div.withConfig({
  displayName: "styles__Container",
  componentId: "sc-1q8c9x9-9"
})(["bottom:auto;top:", ";display:flex;flex-direction:row;align-items:center;position:absolute !important;left:56px;right:0;"], ({
  theme
}) => `calc((${theme.AppFrame.header.height} - ${theme.AppFrame.breadcrumbs.lineHeight}) / 2)`);
const Label = exports.Label = (0, _styledComponents.default)(_Label.default).withConfig({
  displayName: "styles__Label",
  componentId: "sc-1q8c9x9-10"
})(["width:auto;"]);
const HiddenNode = exports.HiddenNode = _styledComponents.default.div.withConfig({
  displayName: "styles__HiddenNode",
  componentId: "sc-1q8c9x9-11"
})(["display:flex;visibility:hidden;position:absolute;top:-9999999px;left:-999999px;"]);